webpackJsonp([8],{

/***/ 103:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAIVBMVEV9mlt9mlv///+dsoOJpGrg59fL173v8uv3+fWsvpW5yKb6MbK8AAAAAXRSTlOArV5bRgAAAS5JREFUeAHt1L9OwzAQBvD2DWolIGW9KNR0ywKzkcjQMaFDVsgTMNG1Qh26FQkxBwZeE/9po8SOPw8RE3i9n9zzd5fO5gyexQzXGfsH08BmU2FAlE4AlyIAPg8YxDt6gOCCiLcIvBFRhkD0LAVssggBdhsC8WMA6DZw1MUZfAVm8ZFhcE90REC99xWAZCfByg+iUtZ56wXXKgxq/E3qU4GVU2fLMFgJG+QDkAkn6pemB5a5M4uEqO4Ab5kD5DbSXvRnYYE7/ctHP9CbRLzxAvZunl/3QDzMYW02ep+fQVRaQUV6At13kZRkJxl/n8agQCIvdKO+6cBaLcTILEwjKStUfQyYRlJz09XoNFUjS10/CLwwW4EXpraTtEDlRD0ETwwCflqeX/kj/ZtgjsHiB/lZsvkHQVMgAAAAAElFTkSuQmCC"

/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginForm__ = __webpack_require__(304);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'LoginView',
	components: {
		LoginForm: __WEBPACK_IMPORTED_MODULE_0__components_LoginForm__["a" /* default */]
	},
	methods: {
		loginSuccess: function loginSuccess(user) {
			this.$router.push({ name: 'content' });
		},
		loginFail: function loginFail(err) {
			this.$dialog(err);
		},
		resetSuccess: function resetSuccess(data) {
			this.$dialog('A password reset email has been sent to: <strong>' + data.email + '</strong>', {
				cancelText: 'OK'
			});
		},
		resetFail: function resetFail(err) {
			this.$dialog(err);
		}
	},
	computed: {
		logo: function logo() {
			var logo = {
				src: __webpack_require__(354),
				height: 82,
				width: 75
			};
			var domains = window.location.host.split('.');
			var sub = domains[0];
			switch (sub) {
				case 'jha':
					logo = {
						src: __webpack_require__(305),
						height: 56,
						width: 248
					};
					break;
				case 'oac':
					logo = {
						src: __webpack_require__(306),
						height: 64,
						width: 112
					};
					break;
				default:
					break;
			}
			return logo;
		}
	}
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FancyInput__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TextField__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_Ripple__ = __webpack_require__(300);








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'loginForm',
	props: {
		onSuccess: Function
	},
	data: function data() {
		return {
			login: {},
			error: null
		};
	},
	components: {
		TextField: __WEBPACK_IMPORTED_MODULE_3__components_TextField__["a" /* default */],
		FancyInput: __WEBPACK_IMPORTED_MODULE_2__components_FancyInput__["a" /* default */]
	},
	directives: {
		Ripple: __WEBPACK_IMPORTED_MODULE_4__directives_Ripple__["a" /* default */]
	},
	methods: {
		submitForm: function submitForm(data) {
			var _this = this;

			this.error = null;
			this.$store.dispatch('loginUser', data).then(function (res) {
				_this.$emit('loginSuccess', data);
			}).catch(function (err) {
				_this.$emit('loginFail', err);
			});
		},
		resetPassword: function resetPassword(data) {
			var _this2 = this;

			if (!data.email) {
				return this.$dialog('Please enter your email address.', {
					cancelText: 'Close'
				});
			}

			this.error = null;
			this.$store.dispatch('sendPasswordReset', data.email).then(function (res) {
				_this2.$emit('resetSuccess', data);
			}).catch(function (err) {
				_this2.$emit('resetFail', err);
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['user']))
});

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'fancyInput',
	props: {
		autocomplete: String,
		type: String,
		name: String,
		label: String,
		placeholder: String,
		required: null,
		help: String,
		hint: String,
		disabled: {
			type: Boolean,
			default: function _default() {
				return false;
			}
		},
		value: {
			type: [String, Number, Boolean, Object, Array],
			default: function _default() {
				return null;
			}
		},
		hasError: Boolean,
		readonly: Boolean
	},
	components: {},
	data: function data() {
		return {
			startTime: {
				time: ''
			},
			passwordVisible: false
		};
	},
	mounted: function mounted() {
		if (!this.$refs || !this.$refs.input) return;

		if (this.$refs.input.value || this.$refs.input.selectedIndex === 0) {
			var parent = this.$refs.input.parentNode.parentNode;
			parent.classList.add('has-data');
		}

		this.$refs.input.addEventListener('focus', function (e) {
			var parent = e.target.parentNode.parentNode;
			parent.classList.add('has-focus');
			parent.classList.add('has-data');
		});

		this.$refs.input.addEventListener('blur', function (e) {
			var parent = e.target.parentNode.parentNode;
			parent.classList.remove('has-focus');
			if (!e.target.value && e.target.selectedIndex !== 0) {
				parent.classList.remove('has-data');
			}
		});
	},

	methods: {
		hasData: function hasData(field) {
			switch (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value)) {
				case 'number':
					return this.value > -1;
				default:
					return (this.value || '').length;
			}
		},
		setFocus: function setFocus(field) {
			this.$refs.input.focus();
		},
		updateValue: function updateValue(e) {
			this.$emit('input', e.target.value);
		},
		passwordToggle: function passwordToggle() {
			this.passwordVisible = !this.passwordVisible;
		}
	},
	computed: {
		inputType: function inputType() {
			if (this.type === 'password' && this.passwordVisible) return 'text';
			return this.type;
		}
	}
});

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_textfield_dist_mdc_textfield__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_textfield_dist_mdc_textfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_textfield_dist_mdc_textfield__);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'textField',
	data: function data() {
		return {
			classes: '',
			foundation: null
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$nextTick(function () {
			setTimeout(function () {
				new __WEBPACK_IMPORTED_MODULE_0__material_textfield_dist_mdc_textfield__["MDCTextField"](_this.$el);
			}, 250);
		});
	}
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'partialHome',
	methods: {
		viewContent: function viewContent(key) {
			this.$router.push({ name: 'contentModel', params: { key: key } });
		},
		addItem: function addItem(key) {
			var _this = this;

			this.$store.dispatch('addItem', key).then(function (id) {
				_this.$router.push({
					name: 'item',
					params: {
						key: key,
						uid: id
					}
				});
			});
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['models']))
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dashboardPartial'
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var files = __webpack_require__(379);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);





var suppressWarn = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].version.indexOf('1.') === 0 ? { transition: { template: '<div><slot></slot></div>' } } : null;

var DEFAULTS = {
	id: 'dialog',
	className: '',
	parent: 'body',
	transition: 'dialog',
	title: 'Alert',
	message: 'Look here',
	cancelText: 'Cancel',
	confirmText: 'Confirm'
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: '',
	data: function data() {
		return {
			queue: [],
			option: {},
			showing: false
		};
	},
	components: suppressWarn,
	computed: {
		merged: function merged() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULTS, this.option);
		}
	},
	methods: {
		close: function close() {
			this.queue.shift();
		},
		confirm: function confirm() {
			if (this.merged.confirm) {
				this.merged.confirm();
				this.queue.shift();
			}
		}
	},
	watch: {
		queue: function queue(to, from) {
			var pending = this.queue.length;
			if (!pending) {
				this.showing = false;
				return;
			}
			this.showing = true;
			this.option = this.queue[0];
		}
	}
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_snackbar__ = __webpack_require__(480);


var _this = this;



var DEFAULTS = {
	message: '',
	timeout: 2750,
	multiline: false,
	actionOnBottom: false,
	actionText: 'close',
	actionHandler: function actionHandler() {
		_this.snackbar.hide();
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'snackbar',
	data: function data() {
		return {
			queue: [],
			option: {},
			timer: null
		};
	},
	mounted: function mounted() {
		this.snackbar = new __WEBPACK_IMPORTED_MODULE_1__material_snackbar__["a" /* MDCSnackbar */](this.$el);
		this.snackbar.dismissesOnAction = true;
	},

	methods: {
		show: function show(options) {
			var opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULTS, options);
			this.snackbar.show(opts);
		}
	},
	computed: {
		merged: function merged() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULTS, this.option);
		}
	},
	watch: {
		queue: function queue(to, from) {
			var _this2 = this;

			var pending = this.queue.length;
			if (!pending) {
				return;
			}

			this.option = this.queue[0];
			var merged = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULTS, this.option);
			this.snackbar.show(merged);
			this.timer = setTimeout(function () {
				_this2.queue.shift();
				clearTimeout(_this2.timer);
			}, merged.timeout);
		}
	}
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var files = __webpack_require__(486);

var FiltersPlugin = {
	install: function install(Vue) {
		files.keys().forEach(function (key) {
			if (key === './index.js') return;
			var name = key.replace(/(\.\/|\.js)/g, '');
			Vue.filter(name, files(key).default);
		});
	}
};

/* harmony default export */ __webpack_exports__["default"] = (FiltersPlugin);

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FancyInput_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6a4af6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FancyInput_vue__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(333)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b6a4af6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FancyInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6a4af6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FancyInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b6a4af6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FancyInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__ = __webpack_require__(115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d06cc07c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(347)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d06cc07c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d06cc07c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d06cc07c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple__ = __webpack_require__(350);


/* harmony default export */ __webpack_exports__["a"] = ({
	bind: function bind(el, context) {
		if (!context.modifiers.custom) {
			el.classList.add('mdc-ripple-surface');
		}
		el.mdc_ripple_ = __WEBPACK_IMPORTED_MODULE_0__material_ripple__["a" /* MDCRipple */].attachTo(el, { isUnbounded: context.modifiers.unbounded });
	},
	unbind: function unbind(el, context) {
		if (!el.mdc_ripple_) {
			return;
		}
		el.mdc_ripple_.destroy();
		delete el.mdc_ripple_;
	}
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_913b10b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(332)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-913b10b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_913b10b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_913b10b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 305:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oac_logo.e3fbaf1.png";

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_router__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_store__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_meta__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_dialog__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_snackbar__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_bus__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_filters__ = __webpack_require__(291);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__lib_dialog__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__lib_snackbar__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__lib_bus__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["default"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
	},
	router: __WEBPACK_IMPORTED_MODULE_2__lib_router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_3__lib_store__["a" /* default */]
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b76f7f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(310)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b76f7f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b76f7f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []


/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_store__ = __webpack_require__(98);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
	mode: 'history',
	routes: __WEBPACK_IMPORTED_MODULE_3__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
	var requiresAuth = null;

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(to.matched), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var match = _step.value;

			if (match.meta.requiresAuth) {
				requiresAuth = true;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	if (requiresAuth) {
		__WEBPACK_IMPORTED_MODULE_4__lib_store__["a" /* default */].dispatch('initUser').then(function (res) {
			next();
		}).catch(function (err) {
			next({ name: 'login' });
			console.warn('Login required.', err);
		});
	} else {
		next();
	}
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Login__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_partials_Home__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_partials_Dashboard__ = __webpack_require__(359);





var Main = function Main(r) {
	return __webpack_require__.e/* require.ensure */(4).then((function () {
		return r(__webpack_require__(498));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MainLeft = function MainLeft(r) {
	return __webpack_require__.e/* require.ensure */(4).then((function () {
		return r(__webpack_require__(499));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MainRight = function MainRight(r) {
	return __webpack_require__.e/* require.ensure */(6).then((function () {
		return r(__webpack_require__(500));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};




var Content = function Content(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(501));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ContentNav = function ContentNav(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(502));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ContentList = function ContentList(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(495));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ContentForm = function ContentForm(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(493));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Contents = function Contents(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(503));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ContentModal = function ContentModal(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(504));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ImportForm = function ImportForm(r) {
	return __webpack_require__.e/* require.ensure */(5).then((function () {
		return r(__webpack_require__(494));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Model = function Model(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(505));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ModelNav = function ModelNav(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(506));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ModelForm = function ModelForm(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(496));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PropertyForm = function PropertyForm(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(497));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PropertyModal = function PropertyModal(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(507));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Profile = function Profile(r) {
	return __webpack_require__.e/* require.ensure */(3).then((function () {
		return r(__webpack_require__(508));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var HomeLeft = function HomeLeft(r) {
	return __webpack_require__.e/* require.ensure */(2).then((function () {
		return r(__webpack_require__(509));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SiteHeader = function SiteHeader(r) {
	return __webpack_require__.e/* require.ensure */(2).then((function () {
		return r(__webpack_require__(510));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SiteFooter = function SiteFooter(r) {
	return __webpack_require__.e/* require.ensure */(2).then((function () {
		return r(__webpack_require__(511));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ProfileForm = function ProfileForm(r) {
	return __webpack_require__.e/* require.ensure */(3).then((function () {
		return r(__webpack_require__(512));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var leftComponents = {
	leftContent: ContentNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter
};

var ContentLeft = {
	leftContent: ContentNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter
};

var ModelLeft = {
	leftContent: ModelNav,
	leftHeader: SiteHeader,
	leftFooter: SiteFooter
};

var ProfileLeft = {
	leftHeader: SiteHeader,
	leftFooter: SiteFooter
};

var MainLeftComponents = {
	leftHeader: SiteHeader,
	leftFooter: SiteFooter
};

var MainComponents = {
	left: MainLeft,
	right: MainRight
};

var routes = [{
	path: '/',
	component: Main,
	meta: {
		requiresAuth: true
	},
	children: [{
		path: '',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: __WEBPACK_IMPORTED_MODULE_2__views_partials_Home__["a" /* default */]
		}),
		children: [{
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ContentNav
			})
		}]
	}, {
		path: 'content',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: __WEBPACK_IMPORTED_MODULE_2__views_partials_Home__["a" /* default */]
		}),
		children: [{
			name: 'content',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ContentNav
			})
		}]
	}, {
		path: 'content/:key/:pg(\\d+)?',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Contents
		}),
		children: [{
			name: 'contentModel',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ContentNav
			})
		}]
	}, {
		path: 'content/:key/:uid',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Content
		}),
		children: [{
			name: 'item',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ContentNav
			})
		}]
	}, {
		path: 'content/:key/:uid/:newKey/:newUid',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Content,
			modal: ContentModal
		}),
		meta: {
			showModal: true,
			title: 'Edit Content'
		},
		children: [{
			name: 'contentModal',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ContentNav
			})
		}]
	}, {
		path: 'model',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Model
		}),
		children: [{
			name: 'model',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ModelNav
			})
		}]
	}, {
		path: 'model/:key',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Model
		}),
		children: [{
			name: 'editModel',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ModelNav
			})
		}]
	}, {
		path: 'model/:key/property',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Model,
			modal: PropertyModal
		}),
		children: [{
			name: 'addProperty',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ModelNav
			}),
			meta: {
				showModal: true,
				title: 'Add Property'
			}
		}]
	}, {
		path: 'model/:key/property/:prop',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Model,
			modal: PropertyModal
		}),
		children: [{
			name: 'editProperty',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ModelNav
			}),
			meta: {
				showModal: true,
				title: 'Edit Property'
			}
		}]
	}, {
		path: 'profile',
		components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainComponents, {
			content: Profile
		}),
		children: [{
			name: 'profile',
			path: '',
			components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, MainLeftComponents, {
				leftContent: ContentNav
			})
		}]
	}]
}, {
	path: '/login',
	name: 'login',
	component: __WEBPACK_IMPORTED_MODULE_1__views_Login__["a" /* default */],
	meta: {
		title: 'Login',
		requiresAuth: false
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d1b5a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(331)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15d1b5a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d1b5a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d1b5a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fancy-field",class:{'has-data':_vm.hasData(_vm.name),'select':_vm.type=='select','has-error':_vm.hasError,'has-placeholder':_vm.placeholder,'has-label':_vm.label}},[_c('label',{attrs:{"for":_vm.name},on:{"click":function($event){_vm.setFocus(_vm.name)}}},[_vm._v("\n\t\t"+_vm._s(_vm.label || _vm.placeholder)+"\n\t\t"),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.help)?_c('i',{staticClass:"icon fancy-field__help",attrs:{"aria-label":_vm.help,"data-tooltip":""}},[_vm._v("help")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fancy-field__input"},[_vm._t("pre"),_vm._v(" "),(_vm.type!=='select'&&_vm.type!=='date')?_c('input',{ref:"input",staticClass:"fancy-control",attrs:{"type":_vm.inputType,"name":_vm.name,"id":_vm.name,"required":_vm.required,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event.target.value)}}}):_vm._e(),_vm._v(" "),_vm._t("post"),_vm._v(" "),(_vm.type==='password')?_c('i',{staticClass:"icon fancy-field__show",domProps:{"innerHTML":_vm._s(_vm.passwordVisible?'visibility_off':'visibility')},on:{"click":function($event){_vm.passwordToggle()}}},[_vm._v("visibility")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"fancy-field__input"},[(_vm.type=='select')?_c('select',{ref:"input",staticClass:"fancy-control",attrs:{"name":_vm.name,"id":_vm.name,"required":_vm.required,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit('input', $event.target.value)}}},[_vm._t("default")],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fancy-msg",class:{'fancy-msg--error':_vm.hasError,'fancy-msg--hint':_vm.hint}},[_vm._t("msg",[_vm._v(_vm._s(_vm.hint))])],2)])}
var staticRenderFns = []


/***/ }),

/***/ 347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-textfield",class:_vm.classes},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"login-form",attrs:{"id":"login_form"},on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();_vm.submitForm(_vm.login)}}},[_c('fancy-input',{attrs:{"type":"email","id":"email","label":"Email Address","required":"required"},model:{value:(_vm.login.email),callback:function ($$v) {_vm.$set(_vm.login, "email", $$v)},expression:"login.email"}}),_vm._v(" "),_c('fancy-input',{attrs:{"type":"password","id":"password","label":"Password","required":"required"},model:{value:(_vm.login.password),callback:function ($$v) {_vm.$set(_vm.login, "password", $$v)},expression:"login.password"}}),_vm._v(" "),_c('button',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"mdc-button mdc-button--raised mdc-button--primary",attrs:{"type":"submit"}},[_vm._v("Login")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"title":"Reset Password"},on:{"click":function($event){_vm.resetPassword(_vm.login)}}},[_vm._v("Forgot password?")])])],1)}
var staticRenderFns = []


/***/ }),

/***/ 354:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view__login"},[_c('div',{staticClass:"view__login-content"},[_c('img',{attrs:{"src":_vm.logo.src,"alt":"Trunk CMS","width":_vm.logo.width,"height":_vm.logo.height}}),_vm._v(" "),_c('login-form',{on:{"loginSuccess":_vm.loginSuccess,"loginFail":_vm.loginFail,"resetSuccess":_vm.resetSuccess,"resetFail":_vm.resetFail}})],1)])}
var staticRenderFns = []


/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02641dac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(357)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02641dac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02641dac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02641dac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 357:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partial partial--home"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"partial__content"},[_c('div',{staticClass:"models-list"},[_vm._l((_vm.models),function(model){return _c('div',{key:model.$key,staticClass:"models-list__item",on:{"click":function($event){_vm.viewContent(model.$key)}}},[_c('i',{staticClass:"models-list__item-icon icon"},[_vm._v(_vm._s(model.icon))]),_vm._v(" "),_c('h5',{staticClass:"models-list__item-title"},[_vm._v(_vm._s(model.plural))]),_vm._v(" "),_c('div',{staticClass:"models-list__item-nav"},[_c('a',{staticClass:"models-list__item-nav__item mdc-button",on:{"click":function($event){_vm.viewContent(model.$key)}}},[_vm._v("View")]),_vm._v(" "),_c('a',{staticClass:"models-list__item-nav__item mdc-button",on:{"click":function($event){_vm.addItem(model.$key)}}},[_vm._v("Add New")])])])}),_vm._v(" "),(!_vm.models.length)?_c('router-link',{staticClass:"models-list__item a",attrs:{"to":"/model/"}},[_c('i',{staticClass:"models-list__item-icon icon"},[_vm._v("add")]),_vm._v(" "),_c('h5',{staticClass:"models-list__item-title"},[_vm._v("Add New Model")])]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__content"},[_c('h5',[_vm._v("Content Types")])])}]


/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(120);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639ea94b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(360)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-639ea94b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639ea94b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639ea94b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 360:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partial partial__dashboard"},[_vm._v("\n\tdashboard\n")])}
var staticRenderFns = []


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 125,
	"./af.js": 125,
	"./ar": 126,
	"./ar-dz": 127,
	"./ar-dz.js": 127,
	"./ar-kw": 128,
	"./ar-kw.js": 128,
	"./ar-ly": 129,
	"./ar-ly.js": 129,
	"./ar-ma": 130,
	"./ar-ma.js": 130,
	"./ar-sa": 131,
	"./ar-sa.js": 131,
	"./ar-tn": 132,
	"./ar-tn.js": 132,
	"./ar.js": 126,
	"./az": 133,
	"./az.js": 133,
	"./be": 134,
	"./be.js": 134,
	"./bg": 135,
	"./bg.js": 135,
	"./bm": 136,
	"./bm.js": 136,
	"./bn": 137,
	"./bn.js": 137,
	"./bo": 138,
	"./bo.js": 138,
	"./br": 139,
	"./br.js": 139,
	"./bs": 140,
	"./bs.js": 140,
	"./ca": 141,
	"./ca.js": 141,
	"./cs": 142,
	"./cs.js": 142,
	"./cv": 143,
	"./cv.js": 143,
	"./cy": 144,
	"./cy.js": 144,
	"./da": 145,
	"./da.js": 145,
	"./de": 146,
	"./de-at": 147,
	"./de-at.js": 147,
	"./de-ch": 148,
	"./de-ch.js": 148,
	"./de.js": 146,
	"./dv": 149,
	"./dv.js": 149,
	"./el": 150,
	"./el.js": 150,
	"./en-au": 151,
	"./en-au.js": 151,
	"./en-ca": 152,
	"./en-ca.js": 152,
	"./en-gb": 153,
	"./en-gb.js": 153,
	"./en-ie": 154,
	"./en-ie.js": 154,
	"./en-il": 155,
	"./en-il.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./eo": 157,
	"./eo.js": 157,
	"./es": 158,
	"./es-do": 159,
	"./es-do.js": 159,
	"./es-us": 160,
	"./es-us.js": 160,
	"./es.js": 158,
	"./et": 161,
	"./et.js": 161,
	"./eu": 162,
	"./eu.js": 162,
	"./fa": 163,
	"./fa.js": 163,
	"./fi": 164,
	"./fi.js": 164,
	"./fo": 165,
	"./fo.js": 165,
	"./fr": 166,
	"./fr-ca": 167,
	"./fr-ca.js": 167,
	"./fr-ch": 168,
	"./fr-ch.js": 168,
	"./fr.js": 166,
	"./fy": 169,
	"./fy.js": 169,
	"./gd": 170,
	"./gd.js": 170,
	"./gl": 171,
	"./gl.js": 171,
	"./gom-latn": 172,
	"./gom-latn.js": 172,
	"./gu": 173,
	"./gu.js": 173,
	"./he": 174,
	"./he.js": 174,
	"./hi": 175,
	"./hi.js": 175,
	"./hr": 176,
	"./hr.js": 176,
	"./hu": 177,
	"./hu.js": 177,
	"./hy-am": 178,
	"./hy-am.js": 178,
	"./id": 179,
	"./id.js": 179,
	"./is": 180,
	"./is.js": 180,
	"./it": 181,
	"./it.js": 181,
	"./ja": 182,
	"./ja.js": 182,
	"./jv": 183,
	"./jv.js": 183,
	"./ka": 184,
	"./ka.js": 184,
	"./kk": 185,
	"./kk.js": 185,
	"./km": 186,
	"./km.js": 186,
	"./kn": 187,
	"./kn.js": 187,
	"./ko": 188,
	"./ko.js": 188,
	"./ky": 189,
	"./ky.js": 189,
	"./lb": 190,
	"./lb.js": 190,
	"./lo": 191,
	"./lo.js": 191,
	"./lt": 192,
	"./lt.js": 192,
	"./lv": 193,
	"./lv.js": 193,
	"./me": 194,
	"./me.js": 194,
	"./mi": 195,
	"./mi.js": 195,
	"./mk": 196,
	"./mk.js": 196,
	"./ml": 197,
	"./ml.js": 197,
	"./mr": 198,
	"./mr.js": 198,
	"./ms": 199,
	"./ms-my": 200,
	"./ms-my.js": 200,
	"./ms.js": 199,
	"./mt": 201,
	"./mt.js": 201,
	"./my": 202,
	"./my.js": 202,
	"./nb": 203,
	"./nb.js": 203,
	"./ne": 204,
	"./ne.js": 204,
	"./nl": 205,
	"./nl-be": 206,
	"./nl-be.js": 206,
	"./nl.js": 205,
	"./nn": 207,
	"./nn.js": 207,
	"./pa-in": 208,
	"./pa-in.js": 208,
	"./pl": 209,
	"./pl.js": 209,
	"./pt": 210,
	"./pt-br": 211,
	"./pt-br.js": 211,
	"./pt.js": 210,
	"./ro": 212,
	"./ro.js": 212,
	"./ru": 213,
	"./ru.js": 213,
	"./sd": 214,
	"./sd.js": 214,
	"./se": 215,
	"./se.js": 215,
	"./si": 216,
	"./si.js": 216,
	"./sk": 217,
	"./sk.js": 217,
	"./sl": 218,
	"./sl.js": 218,
	"./sq": 219,
	"./sq.js": 219,
	"./sr": 220,
	"./sr-cyrl": 221,
	"./sr-cyrl.js": 221,
	"./sr.js": 220,
	"./ss": 222,
	"./ss.js": 222,
	"./sv": 223,
	"./sv.js": 223,
	"./sw": 224,
	"./sw.js": 224,
	"./ta": 225,
	"./ta.js": 225,
	"./te": 226,
	"./te.js": 226,
	"./tet": 227,
	"./tet.js": 227,
	"./tg": 228,
	"./tg.js": 228,
	"./th": 229,
	"./th.js": 229,
	"./tl-ph": 230,
	"./tl-ph.js": 230,
	"./tlh": 231,
	"./tlh.js": 231,
	"./tr": 232,
	"./tr.js": 232,
	"./tzl": 233,
	"./tzl.js": 233,
	"./tzm": 234,
	"./tzm-latn": 235,
	"./tzm-latn.js": 235,
	"./tzm.js": 234,
	"./ug-cn": 236,
	"./ug-cn.js": 236,
	"./uk": 237,
	"./uk.js": 237,
	"./ur": 238,
	"./ur.js": 238,
	"./uz": 239,
	"./uz-latn": 240,
	"./uz-latn.js": 240,
	"./uz.js": 239,
	"./vi": 241,
	"./vi.js": 241,
	"./x-pseudo": 242,
	"./x-pseudo.js": 242,
	"./yo": 243,
	"./yo.js": 243,
	"./zh-cn": 244,
	"./zh-cn.js": 244,
	"./zh-hk": 245,
	"./zh-hk.js": 245,
	"./zh-tw": 246,
	"./zh-tw.js": 246
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./content.js": 380,
	"./index.js": 247,
	"./model.js": 468,
	"./nav.js": 469,
	"./user.js": 470
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_fb__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_path__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(61);





var _mutations;







var state = {
	content: [],
	item: {},
	page: {
		current: 1,
		limit: 50,
		count: 1
	},
	search: {
		keyword: null,
		keys: [],
		sort: 'createdAt'
	},
	sort: {
		field: 'createdAt',
		reverse: true
	}
};

var actions = {
	loadContent: Object(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref, key) {
		var rootState = _ref.rootState,
		    bindFirebaseRef = _ref.bindFirebaseRef,
		    commit = _ref.commit;

		commit(__WEBPACK_IMPORTED_MODULE_7__types__["d" /* SET_LOADING */], true);
		var contentPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, key);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(contentPath);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			bindFirebaseRef('content', contentRef, { readyCallback: function readyCallback() {
					commit(__WEBPACK_IMPORTED_MODULE_7__types__["d" /* SET_LOADING */], false);
					resolve();
				} });
		});
	}),
	unloadContent: Object(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref2) {
		var commit = _ref2.commit,
		    unbindFirebaseRef = _ref2.unbindFirebaseRef;

		commit(__WEBPACK_IMPORTED_MODULE_7__types__["j" /* UNLOAD_CONTENT */]);

		try {
			unbindFirebaseRef('content');
		} catch (e) {}
	}),
	loadItem: Object(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref3, ref) {
		var rootState = _ref3.rootState,
		    bindFirebaseRef = _ref3.bindFirebaseRef;

		var itemPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, ref);
		var itemRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(itemPath);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			bindFirebaseRef('item', itemRef, { readyCallback: function readyCallback() {
					resolve();
				} });
		});
	}),
	unloadItem: Object(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref4, ref) {
		var commit = _ref4.commit,
		    unbindFirebaseRef = _ref4.unbindFirebaseRef;

		try {
			unbindFirebaseRef('item');
		} catch (e) {}
	}),
	loadContentAlt: Object(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref5, key) {
		var rootState = _ref5.rootState,
		    bindFirebaseRef = _ref5.bindFirebaseRef;

		var contentPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, key);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(contentPath);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			bindFirebaseRef('contentAlt', contentRef, { readyCallback: function readyCallback() {
					resolve();
				} });
		});
	}),
	unloadContentAlt: Object(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref6) {
		var commit = _ref6.commit,
		    unbindFirebaseRef = _ref6.unbindFirebaseRef;

		commit(__WEBPACK_IMPORTED_MODULE_7__types__["j" /* UNLOAD_CONTENT */]);
		try {
			unbindFirebaseRef('contentAlt');
		} catch (e) {}
	}),
	loadContentLocal: function loadContentLocal(_ref7, key) {
		var rootState = _ref7.rootState,
		    commit = _ref7.commit;

		var contentPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, key);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(contentPath);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			contentRef.once('value').then(function (snap) {
				resolve(__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepOut(snap, true));
			});
		});
	},
	loadItemLocal: function loadItemLocal(_ref8, key) {
		var rootState = _ref8.rootState,
		    commit = _ref8.commit;

		var itemPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, key);
		var itemRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(itemPath);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			itemRef.once('value').then(function (snap) {
				resolve(__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepOut(snap));
			});
		});
	},
	addItem: function addItem(_ref9, ref) {
		var commit = _ref9.commit,
		    rootState = _ref9.rootState;

		var contentPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, ref);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(contentPath);
		var item = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn({});
		var newRef = contentRef.push();
		var key = newRef.key;

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			newRef.set(item, function (res) {
				resolve(key);
			});
		});
	},
	removeItem: function removeItem(_ref10, data) {
		var commit = _ref10.commit;

		var ref = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].ref(data);

		return __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(ref).remove();
	},
	updateItem: function updateItem(_ref11, data) {
		var commit = _ref11.commit,
		    rootState = _ref11.rootState;

		var ref = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].ref(data);
		var item = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn(data);
		var key = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].key(data);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(ref);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			contentRef.update(item, function (res) {
				resolve(key);
			});
		});
	},
	updateItemPriority: function updateItemPriority(_ref12, data) {
		var commit = _ref12.commit,
		    rootState = _ref12.rootState;

		var ref = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].ref(data);
		var item = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn(data, false);
		var key = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].key(data);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(ref);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			contentRef.update(item, function (res) {
				resolve(key);
			});
		});
	},
	uploadImage: function uploadImage(_ref13, data) {
		var commit = _ref13.commit;

		var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)[0];
		var val = data[key];
		var storageRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].storage().ref(key);
		var img = new Image();
		var _url = window.URL || window.webkitURL;

		var height = 0;
		var width = 0;
		var dimensions = {
			height: 0,
			width: 0
		};
		img.onload = function () {
			dimensions.height = this.height;
			dimensions.width = this.width;
			height = this.height;
			width = this.width;
		};
		img.src = _url.createObjectURL(val);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var upload = storageRef.put(val);
			upload.on(__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].storage.TaskEvent.STATE_CHANGED, function (snap) {}, function (err) {
				reject(err);
			}, function (res) {
				var toReturn = {
					downloadURL: upload.snapshot.downloadURL,
					contentType: upload.snapshot.metadata.contentType,
					fullPath: upload.snapshot.metadata.fullPath,
					height: height,
					name: upload.snapshot.metadata.name,
					size: upload.snapshot.metadata.size,
					width: width
				};
				resolve(toReturn);
			});
		});
	},
	uploadFile: function uploadFile(_ref14, data) {
		var commit = _ref14.commit;

		var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)[0];
		var val = data[key];
		var storageRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].storage().ref(key);

		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var upload = storageRef.put(val);
			upload.on(__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].storage.TaskEvent.STATE_CHANGED, function (snap) {}, function (err) {
				reject(err);
			}, function (res) {
				var toReturn = {
					downloadURL: upload.snapshot.downloadURL,
					contentType: upload.snapshot.metadata.contentType,
					size: upload.snapshot.metadata.size,
					fullPath: upload.snapshot.metadata.fullPath,
					name: upload.snapshot.metadata.name
				};
				resolve(toReturn);
			});
		});
	},
	setPage: function setPage(_ref15, page) {
		var commit = _ref15.commit;

		commit(__WEBPACK_IMPORTED_MODULE_7__types__["e" /* SET_PAGE */], parseInt(page, 10));
	},
	setSearch: function setSearch(_ref16, data) {
		var commit = _ref16.commit;

		if (typeof data.keyword !== 'string') return;
		commit(__WEBPACK_IMPORTED_MODULE_7__types__["g" /* SET_SEARCH */], data);
	},
	setSortField: function setSortField(_ref17, data) {
		var commit = _ref17.commit;

		commit(__WEBPACK_IMPORTED_MODULE_7__types__["i" /* SET_SORT_FIELD */], data);
	},
	appendContent: function appendContent(_ref18, data) {
		var commit = _ref18.commit,
		    rootState = _ref18.rootState;

		var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)[0];
		var val = data[key];
		var contentPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, key);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(contentPath);
		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			contentRef.update(val, function (err) {
				if (err) {
					reject(err);
				} else {
					resolve(val);
				}
			});
		});
	},
	replaceContent: function replaceContent(_ref19, data) {
		var commit = _ref19.commit,
		    rootState = _ref19.rootState;

		var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)[0];
		var val = data[key];
		var contentPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.content, key);
		var contentRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(contentPath);
		return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			contentRef.set(val, function (err) {
				if (err) {
					reject(err);
				} else {
					resolve(val);
				}
			});
		});
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["j" /* UNLOAD_CONTENT */], function (state) {
	state.content = [];
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["k" /* UNLOAD_ITEM */], function (state) {
	state.item = {};
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["d" /* SET_LOADING */], function (state, loading) {
	state.loading = loading;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["e" /* SET_PAGE */], function (state, page) {
	state.page.current = page;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["f" /* SET_PAGE_LIMIT */], function (state, limit) {
	state.page.limit = limit;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["g" /* SET_SEARCH */], function (state, search) {
	state.search.keys = search.keys;
	if (search.keyword.length < 3) {
		state.search.keyword = '';
	} else {
		state.search.keyword = search.keyword;
	}
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["i" /* SET_SORT_FIELD */], function (state, field) {
	if (state.sort.field === field) {
		state.sort.reverse = !state.sort.reverse;
	} else {
		state.sort.field = field;
	}
}), _mutations);

var getters = {
	contents: function contents(state) {
		return state.contents;
	},
	content: function content(state) {
		if (!state.content.length) return state.content;

		var filtered = state.content.filter(function (item) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(state.search.keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var key = _step.value;

					return (item[key] || '').toLowerCase().indexOf(state.search.keyword.toLowerCase()) > -1;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return item;
		});

		var clean = function clean(str) {
			if (typeof str === 'number') return str;
			return String(str).replace(/\W/g, '').toLowerCase();
		};

		var current = state.page.current;
		filtered.sort(function (a, b) {
			if (clean(a[state.sort.field]) < clean(b[state.sort.field])) return state.sort.reverse ? 1 : -1;
			if (clean(a[state.sort.field]) > clean(b[state.sort.field])) return state.sort.reverse ? -1 : 1;
			return 0;
		});

		state.page.count = Math.ceil(filtered.length / state.page.limit);
		var content = [];
		var page = Math.max(0, current - 1);
		var start = page * state.page.limit;
		var limit = start + state.page.limit;
		for (var i = start; i < limit; i++) {
			if (filtered[i]) {
				content.push(filtered[i]);
			}
		}

		return content;
	},
	allContent: function allContent(state) {
		return state.content;
	},
	item: function item(state) {
		return state.item;
	},
	page: function page(state) {
		return state.page;
	},
	sort: function sort(state) {
		return state.sort;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuexfire__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_fb__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_path__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(61);



var _mutations;







var state = {
	models: [],
	model: {}
};

var actions = {
	loadModels: Object(__WEBPACK_IMPORTED_MODULE_2_vuexfire__["firebaseAction"])(function (_ref) {
		var rootState = _ref.rootState,
		    commit = _ref.commit,
		    bindFirebaseRef = _ref.bindFirebaseRef;

		commit(__WEBPACK_IMPORTED_MODULE_5__types__["d" /* SET_LOADING */], true);
		var modelsPath = rootState.user.refs.model;
		var modelsRef = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(modelsPath);
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			bindFirebaseRef('models', modelsRef, { readyCallback: function readyCallback() {
					commit(__WEBPACK_IMPORTED_MODULE_5__types__["d" /* SET_LOADING */], false);
					resolve();
				} });
		});
	}),
	unloadModels: Object(__WEBPACK_IMPORTED_MODULE_2_vuexfire__["firebaseAction"])(function (_ref2) {
		var commit = _ref2.commit,
		    unbindFirebaseRef = _ref2.unbindFirebaseRef;

		try {
			unbindFirebaseRef('models');
		} catch (e) {}
	}),
	loadModel: Object(__WEBPACK_IMPORTED_MODULE_2_vuexfire__["firebaseAction"])(function (_ref3, key) {
		var rootState = _ref3.rootState,
		    commit = _ref3.commit,
		    bindFirebaseRef = _ref3.bindFirebaseRef;

		commit(__WEBPACK_IMPORTED_MODULE_5__types__["d" /* SET_LOADING */], true);
		var modelPath = __WEBPACK_IMPORTED_MODULE_4_path___default.a.join(rootState.user.refs.model, key);
		var modelRef = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(modelPath);
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			bindFirebaseRef('model', modelRef, { readyCallback: function readyCallback() {
					commit(__WEBPACK_IMPORTED_MODULE_5__types__["d" /* SET_LOADING */], false);
					resolve();
				} });
		});
	}),
	unloadModel: Object(__WEBPACK_IMPORTED_MODULE_2_vuexfire__["firebaseAction"])(function (_ref4) {
		var commit = _ref4.commit,
		    unbindFirebaseRef = _ref4.unbindFirebaseRef;

		commit(__WEBPACK_IMPORTED_MODULE_5__types__["l" /* UNLOAD_MODEL */]);
		try {
			unbindFirebaseRef('model');
		} catch (e) {}
	}),
	loadModelsLocal: function loadModelsLocal(_ref5) {
		var rootState = _ref5.rootState,
		    commit = _ref5.commit;

		var modelsPath = rootState.user.refs.model;
		var modelsRef = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(modelsPath);
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			modelsRef.once('value').then(function (snap) {
				resolve(__WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].prepOut(snap, true));
			});
		});
	},
	loadModelLocal: function loadModelLocal(_ref6, key) {
		var rootState = _ref6.rootState,
		    commit = _ref6.commit;

		var modelPath = __WEBPACK_IMPORTED_MODULE_4_path___default.a.join(rootState.user.refs.model, key);
		var modelRef = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(modelPath);
		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			modelRef.once('value').then(function (snap) {
				resolve(__WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].prepOut(snap));
			});
		});
	},
	addModel: function addModel(_ref7, data) {
		var rootState = _ref7.rootState,
		    commit = _ref7.commit;

		var key = data.key;
		var model = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].prepIn(data);
		var modelsPath = rootState.user.refs.model;
		var modelsRef = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(modelsPath);

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			modelsRef.child(key).set(model).then(function (res) {
				return resolve(key);
			}).catch(function (err) {
				return reject(err);
			});
		});
	},
	removeModel: function removeModel(_ref8, data) {
		var commit = _ref8.commit;

		var ref = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].ref(data);

		return __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(ref).remove();
	},
	updateModel: function updateModel(_ref9, data) {
		var commit = _ref9.commit;

		var key = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].key(data);
		var model = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].prepIn(data);
		var ref = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].ref(data);
		var modelRef = __WEBPACK_IMPORTED_MODULE_3__lib_fb__["a" /* default */].database().ref(ref);

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			modelRef.update(model).then(function () {
				resolve(key);
			});
		});
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__types__["l" /* UNLOAD_MODEL */], function (state) {
	state.model = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__types__["m" /* UNLOAD_MODELS */], function (state) {
	state.models = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__types__["d" /* SET_LOADING */], function (state, loading) {
	state.loading = loading;
}), _mutations);

var getters = {
	models: function models(state) {
		return state.models;
	},
	model: function model(state) {
		var priority = 0;
		for (var prop in state.model.properties) {
			if (Object.prototype.hasOwnProperty.call(state.model.properties, prop)) {
				state.model.properties[prop]['.priority'] = priority;
				priority++;
			}
		}

		return state.model;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(61);




var state = {
	nav: {
		open: false,
		items: {
			content: {
				label: 'Content',
				title: 'Manage Site Content'
			},
			model: {
				label: 'Models',
				title: 'Manage Content Models'
			}
		}
	}
};

var actions = {
	navToggle: function navToggle(_ref, toggle) {
		var commit = _ref.commit;

		commit(__WEBPACK_IMPORTED_MODULE_1__types__["c" /* NAV_TOGGLE */], toggle);
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* NAV_TOGGLE */], function (state, toggle) {
	if (toggle === undefined) {
		state.nav.open = !state.nav.open;
	} else {
		state.nav.open = toggle;
	}
});

var getters = {
	nav: function nav(state) {
		return state.nav;
	},
	navState: function navState(state) {
		return state.nav.open;
	},
	navItems: function navItems(state) {
		return state.nav.items;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_fb__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_path__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(61);






var _mutations;

var buildUser = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(data) {
		var userSnap, userData, user, siteSnap, siteData;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref('users').child(data.uid).once('value');

					case 2:
						userSnap = _context.sent;
						userData = userSnap.val();
						user = {
							user: data,
							site: {},
							refs: {}
						};

						if (!userData.siteId) {
							_context.next = 18;
							break;
						}

						_context.next = 8;
						return __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref('sites').child(userData.siteId).once('value');

					case 8:
						siteSnap = _context.sent;
						siteData = siteSnap.val();

						if (!siteData) {
							_context.next = 15;
							break;
						}

						user.site = siteData;

						user.refs = new __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].refs(userData.siteId);
						_context.next = 16;
						break;

					case 15:
						return _context.abrupt('return');

					case 16:
						_context.next = 19;
						break;

					case 18:
						return _context.abrupt('return');

					case 19:
						return _context.abrupt('return', user);

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function buildUser(_x) {
		return _ref9.apply(this, arguments);
	};
}();






var state = {
	user: {},
	site: {},
	refs: {}
};

var actions = {
	initUser: function initUser(_ref) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().onAuthStateChanged(function (user) {
				if (user) {
					buildUser(user).then(function (res) {
						commit(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* LOGIN_USER */], res);
						resolve(user);
					});
				} else {
					commit(__WEBPACK_IMPORTED_MODULE_7__types__["b" /* LOGOUT_USER */]);
					reject();
				}
			});
		});
	},
	loginUser: function loginUser(_ref2, login) {
		var commit = _ref2.commit;

		var signin = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().signInWithEmailAndPassword(login.email, login.password);
		signin.then(function (res) {
			buildUser(res).then(function (user) {
				commit(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* LOGIN_USER */], user);
			});
		});
		return signin;
	},
	logoutUser: function logoutUser(_ref3) {
		var commit = _ref3.commit;

		var signout = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().signOut();
		signout.then(function (res) {
			commit(__WEBPACK_IMPORTED_MODULE_7__types__["b" /* LOGOUT_USER */]);
		});
		return signout;
	},
	createUser: function createUser(_ref4, data) {
		var rootState = _ref4.rootState,
		    bindFirebaseRef = _ref4.bindFirebaseRef,
		    commit = _ref4.commit;

		var usersPath = __WEBPACK_IMPORTED_MODULE_6_path___default.a.join(rootState.user.refs.users);
		var usersRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(usersPath);
		var item = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn(data);
		var newRef = usersRef.push();
		var key = newRef.key;

		return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			newRef.set(item, function (res) {
				resolve(key);
			});
		});
	},
	authenticateUser: function authenticateUser(_ref5, data) {
		var commit = _ref5.commit;

		var credential = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
		var user = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().currentUser;
		return user.reauthenticateWithCredential(credential);
	},
	updatePassword: function updatePassword(_ref6, data) {
		var rootState = _ref6.rootState,
		    commit = _ref6.commit;

		var user = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().currentUser;
		return user.updatePassword(data);
	},
	updateEmail: function updateEmail(_ref7, data) {
		var commit = _ref7.commit;

		var user = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().currentUser;
		return user.updateEmail(data);
	},
	sendPasswordReset: function sendPasswordReset(_ref8, email) {
		var commit = _ref8.commit;

		return __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].auth().sendPasswordResetEmail(email);
	}
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["a" /* LOGIN_USER */], function (state, data) {
	state.user = data.user;
	state.site = data.site;
	state.refs = data.refs;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["b" /* LOGOUT_USER */], function (state) {
	state.user = {};
	state.refs = {};
	state.content = [];
	state.item = {};
	state.models = [];
	state.model = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["h" /* SET_SITE */], function (state, data) {
	state.site = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["n" /* UNSET_SITE */], function (state) {
	state.site = {};
}), _mutations);

var getters = {
	user: function user(state) {
		return state.user;
	},
	site: function site(state) {
		return state.site;
	},
	refs: function refs(state) {
		return state.refs;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_meta__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_meta___default.a);

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog_vue__ = __webpack_require__(474);


var DialogPlugin = {
	install: function install(Vue) {
		var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		var CONSTRUCTOR = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__Dialog_vue__["a" /* default */]);
		var CACHE = {};

		function dialog(msg) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			options.message = msg;
			var dialog = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR());
			if (!dialog.$el) {
				var vm = dialog.$mount();
				document.querySelector(options.parent || 'body').appendChild(vm.$el);
			}
			dialog.queue.push(options);
		}

		Vue.dialog = Vue.prototype.$dialog = dialog;
	}
};

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(DialogPlugin);
}

/* harmony default export */ __webpack_exports__["a"] = (DialogPlugin);

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ef98d96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(475)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ef98d96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ef98d96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ef98d96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showing),expression:"showing"}],staticClass:"dialog-mask",on:{"click":function($event){_vm.close()}}},[_c('div',{staticClass:"dialog-wrapper"},[_c('div',{staticClass:"dialog-container",on:{"click":function($event){$event.stopPropagation();}}},[_c('header',{staticClass:"dialog-header"},[_c('h5',[_vm._v(_vm._s(_vm.merged.title))])]),_vm._v(" "),_c('article',{staticClass:"dialog-content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.merged.message)}})]),_vm._v(" "),_c('footer',{staticClass:"dialog-footer"},[_c('a',{staticClass:"mdc-button mdc-button--dense mdc-theme--secondary",on:{"click":function($event){_vm.close()}}},[_vm._v(_vm._s(_vm.merged.cancelText))]),_vm._v(" "),(_vm.merged.confirm)?_c('a',{staticClass:"mdc-button mdc-button--primary",on:{"click":function($event){_vm.confirm()}}},[_vm._v(_vm._s(_vm.merged.confirmText))]):_vm._e()])])])])])}
var staticRenderFns = []


/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Snackbar_vue__ = __webpack_require__(478);


var SnackbarPlugin = {
	install: function install(Vue) {
		var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		var CONSTRUCTOR = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__Snackbar_vue__["a" /* default */]);
		var CACHE = {};

		function snackbar(msg) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			options.message = msg;
			var snackbar = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR());
			if (!snackbar.$el) {
				var vm = snackbar.$mount();
				document.querySelector(options.parent || 'body').appendChild(vm.$el);
			}
			snackbar.queue.push(options);
		}

		Vue.snackbar = Vue.prototype.$snackbar = snackbar;
	}
};

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(SnackbarPlugin);
}

/* harmony default export */ __webpack_exports__["a"] = (SnackbarPlugin);

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7062e5ee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(12);
function injectStyle (context) {
  __webpack_require__(479)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7062e5ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Snackbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7062e5ee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7062e5ee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Snackbar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-snackbar",attrs:{"aria-live":"assertive","aria-atomic":"true","aria-hidden":"true"}},[_c('div',{staticClass:"mdc-snackbar__text"}),_vm._v(" "),_c('div',{staticClass:"mdc-snackbar__action-wrapper"},[_c('button',{staticClass:"mdc-button mdc-snackbar__action-button",attrs:{"type":"button"}})])])}]


/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var BusPlugin = {
	install: function install(Vue) {
		var BUS = new Vue();

		Vue.bus = BUS;
		Vue.prototype.$bus = BUS;
	}
};

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(BusPlugin);
}

/* harmony default export */ __webpack_exports__["a"] = (BusPlugin);

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dateFormat.js": 487,
	"./fileSize.js": 488,
	"./index.js": 291,
	"./markdown.js": 489,
	"./timeAgo.js": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["default"] = (function (input) {
	var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YYYY';

	if (input) {
		return __WEBPACK_IMPORTED_MODULE_0_moment___default()(input).format(format);
	}
});

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getReadableFileSizeString;

function getReadableFileSizeString(size) {

    var i = -1;
    var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        size = size / 1024;
        i++;
    } while (size > 1024);

    return Math.max(size, 0.1).toFixed(1) + byteUnits[i];
}

/***/ }),

/***/ 489:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);


/* harmony default export */ __webpack_exports__["default"] = (function (input) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	if (!input) return input;
	return __WEBPACK_IMPORTED_MODULE_0_marked___default()(input, options);
});

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["default"] = (function (input) {
	var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	return __WEBPACK_IMPORTED_MODULE_0_moment___default()(input).fromNow(suffix);
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FB_INIT */
/* unused harmony export FB_OBJECT */
/* unused harmony export FB_ARRAY */
/* unused harmony export FB_ADD */
/* unused harmony export FB_CHANGE */
/* unused harmony export FB_MOVE */
/* unused harmony export FB_REMOVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAV_TOGGLE; });
/* unused harmony export LOAD_CONTENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UNLOAD_CONTENT; });
/* unused harmony export LOAD_ITEM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UNLOAD_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_PAGE_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SORT_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UNLOAD_MODEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UNLOAD_MODELS; });
/* unused harmony export CREATE_USER */
/* unused harmony export UPDATE_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT_USER; });
/* unused harmony export AUTHENTICATE_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UNSET_SITE; });
/* unused harmony export UPDATE_USER_EMAIL */
/* unused harmony export UPDATE_USER_PASSWORD */
/* unused harmony export UPDATE_USER_PROFILE */
/* unused harmony export RESET_USER_PASSWORD */

var FB_INIT = 'FB_INIT';
var FB_OBJECT = 'FB_OBJECT';
var FB_ARRAY = 'FB_ARRAY';
var FB_ADD = 'FB_ADD';
var FB_CHANGE = 'FB_CHANGE';
var FB_MOVE = 'FB_MOVE';
var FB_REMOVE = 'FB_REMOVE';

var NAV_TOGGLE = 'NAV_TOGGLE';

var LOAD_CONTENT = 'LOAD_CONTENT';
var UNLOAD_CONTENT = 'UNLOAD_CONTENT';
var LOAD_ITEM = 'LOAD_ITEM';
var UNLOAD_ITEM = 'UNLOAD_ITEM';
var SET_LOADING = 'SET_LOADING';
var SET_PAGE = 'SET_PAGE';
var SET_PAGE_LIMIT = 'SET_PAGE_LIMIT';
var SET_SEARCH = 'SET_SEARCH';
var SET_SORT_FIELD = 'SET_SORT_FIELD';

var UNLOAD_MODEL = 'UNLOAD_MODEL';
var UNLOAD_MODELS = 'UNLOAD_MODELS';

var CREATE_USER = 'CREATE_USER';
var UPDATE_USER = 'UPDATE_USER';
var LOGIN_USER = 'LOGIN_USER';
var LOGOUT_USER = 'LOGOUT_USER';
var AUTHENTICATE_USER = 'AUTHENTICATE_USER';
var SET_SITE = 'SET_SITE';
var UNSET_SITE = 'UNSET_SITE';
var UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
var UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
var UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
var RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_path__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_app_json__);








__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a.firebase);

var prepIn = function prepIn(data) {
	var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	if (timestamp) {
		if (data.createdAt) {
			data.updatedAt = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database.ServerValue.TIMESTAMP;
		} else {
			data.createdAt = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database.ServerValue.TIMESTAMP;
		}
	}

	var res = {};
	for (var _key in data) {
		if (_key.indexOf('$') !== 0) {
			if (data[_key] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data[_key]) === 'object') {
				res[_key] = prepIn(data[_key], false);
			} else {
				res[_key] = data[_key];
			}
		}
	}

	if (data.$priority || data['.priority']) {
		res['.priority'] = data.$priority || data['.priority'];
	}

	delete res['.key'];

	return res;
};

var newID = function () {
	var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';

	var lastPushTime = 0;

	var lastRandChars = [];

	return function () {
		var now = new Date().getTime();
		var duplicateTime = now === lastPushTime;
		lastPushTime = now;

		var timeStampChars = new Array(8);
		for (var i = 7; i >= 0; i--) {
			timeStampChars[i] = PUSH_CHARS.charAt(now % 64);

			now = Math.floor(now / 64);
		}
		if (now !== 0) throw new Error('We should have converted the entire timestamp.');

		var id = timeStampChars.join('');

		if (duplicateTime) {
			var _i = 11;
			for (_i = 11; _i >= 0 && lastRandChars[_i] === 63; _i--) {
				lastRandChars[_i] = 0;
			}
			lastRandChars[_i]++;
		} else {
			for (var _i2 = 0; _i2 < 12; _i2++) {
				lastRandChars[_i2] = Math.floor(Math.random() * 64);
			}
		}
		for (var _i3 = 0; _i3 < 12; _i3++) {
			id += PUSH_CHARS.charAt(lastRandChars[_i3]);
		}
		if (id.length !== 20) throw new Error('Length should be 20.');

		return id;
	};
}();

var _buildObject = function _buildObject(snap) {
	var val = snap.val();
	var ref = snap.ref.toString().replace(__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a.firebase.databaseURL, '');
	var key = snap.key;
	var priority = snap.getPriority();
	var length = snap.numChildren();

	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, val, {
		$key: key,
		$id: key,
		$ref: ref,
		$priority: priority,
		$length: length
	});
};

var prepOut = function prepOut(data, isArray) {
	if (isArray) {
		var res = [];
		data.forEach(function (snap) {
			res.push(_buildObject(snap));
		});
		return res;
	}
	return _buildObject(data);
};

var key = function key(data) {
	return data.$key;
};

var ref = function ref(data) {
	return data.$ref.replace(__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a.firebase.databaseURL, '');
};

var Refs = function Refs(siteId) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Refs);

	this.owners = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('owners');

	if (siteId) {
		this.site = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('sites', siteId);
		this.content = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('content', siteId);
		this.model = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('model', siteId);
		this.users = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('users', siteId);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	auth: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth,
	database: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database,
	storage: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage,
	prepIn: prepIn,
	prepOut: prepOut,
	newID: newID,
	key: key,
	refs: Refs,
	ref: ref
});

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports = {"firebase":{"apiKey":"AIzaSyAmYYQyvIsH_4Zg1eR2yzK8gB-R2mE56-k","authDomain":"trunk-cms.firebaseapp.com","databaseURL":"https://trunk-cms.firebaseio.com","projectId":"trunk-cms","storageBucket":"trunk-cms.appspot.com","messagingSenderId":"683993747789"},"google":{"apiKey":"AIzaSyCpsXxCdiUSILSFE_l5lJ13mZf3cC1mdnM"}}

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(247);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);



/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3_vuexfire__["firebaseMutations"]),
  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["default"]
}));

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_json__);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['site'])),
	metaInfo: function metaInfo() {
		return {
			title: '' + (this.site.name || 'Trunk'),
			titleTemplate: '%s | CMS',
			meta: [{
				charset: 'utf-8'
			}, {
				'http-equiv': 'X-UA-Compatible',
				content: 'IE=edge'
			}, {
				name: 'description',
				content: 'Trunk CMS - A GraphQL Powered Headless CMS'
			}, {
				name: 'viewport',
				content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui'
			}],
			link: [{
				rel: 'icon',
				href: __webpack_require__(103),
				type: 'image/png'
			}, {
				rel: 'apple-touch-icon',
				href: __webpack_require__(103),
				type: 'image/png'
			}, {
				rel: 'stylesheet',
				href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500|Nunito+Sans:300,400,600,700,800,900|Lato|Material+Icons',
				type: 'text/css'
			}],
			script: [{
				type: 'text/javascript',

				src: 'https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a.google.apiKey
			}]
		};
	}
});

/***/ })

},[307]);


// WEBPACK FOOTER //
// static/js/app.3ce9eb79cb828c134bf3.js